import React from "react";

export const Loading = ({ children }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "24px",
        fontWeight: "600",
      }}
    >
      {children || "Loading..."}
    </div>
  );
};

export default Loading;
